import { LoadingService } from '../../../../../shared/services/loading/loading.service';

export const editPrintListTabLoadingService = new LoadingService();
